import React from 'react';
import { I18n } from 'src/domains/layouts/webview/components/language/I18n';
import { EachWayDetailsWrapper } from './EachWayDetails.style';
import { observer } from 'src/utils/mobx-react';

interface EachWayDetailsPropsType {
    terms: {
        places: number;
        reduction?: string;
    };
}

export const EachWayDetails = observer('EachWayDetails', ({ terms }: EachWayDetailsPropsType): JSX.Element | null => {
    return (
        <EachWayDetailsWrapper>
            <span>
                <I18n
                    defaultText='EW Terms'
                    langKey='events.market-group.each-way-terms.label'
                />
            </span>

            {terms.reduction !== undefined && <span>{terms.reduction}</span>}

            <span>
                <I18n
                    defaultText='{places} Places'
                    langKey='events.market-group.each-way-terms.places'
                    params={{ places: terms.places }}
                />
            </span>
        </EachWayDetailsWrapper>
    );
});
